import React, { Fragment, useState } from 'react'
import { Panel, Button, Feedback, IconVerify } from '@wf-wfria/pioneer-core'
import { FormattedMessage } from 'react-intl'
import { sanitizeLegalContent } from '../sanitizeLegalContent'
import {
	PLINFOLEASE,
	RICOH,
	WFINFOLEASE,
	FORDPRO,
} from '../businessSegmentBrandIds'
import {
	BasicText,
	BasicPrintArea,
	BasicPrintButton,
} from '@wellsfargo/ecpfs-react-data-driven-components'

export function TermsAndConditionsContent({ termsToDisplay }) {
	return (
		<div data-wf-efmya-rfi-toc id="TermsAndConditionsContent">
			<BasicText text={sanitizeLegalContent(termsToDisplay)} inline={true} />
		</div>
	)
}

export function TermsAndConditionsDeclineButton({
	onDeclineTerms,
	mode,
	formatMessage,
}) {
	const [panelOpen, setPanelOpen] = useState(false)
	function togglePanelOpen() {
		setPanelOpen(!panelOpen)
	}
	function declineContent() {
		return formatMessage({
			id: 'terms-and-conditions-page.alert.message-onboard',
		})
	}
	return (
		<Panel
			onClose={togglePanelOpen}
			title={formatMessage({
				id: 'terms-and-conditions-decline-verification',
			})}
			open={panelOpen}
			trigger={
				<span data-wf-efmya-terms-and-conditions-decline-button>
					<Button
						label={formatMessage({
							id: 'terms-and-conditions.footer.button.decline.label',
						})}
						kind="chromeless"
						onClick={togglePanelOpen}
					/>
				</span>
			}
			footer={
				<div data-wf-efmya-terms-and-conditions-decline-footer>
					<Button
						kind="primary"
						label={formatMessage({
							id: 'terms-and-conditions.footer.button.decline.label',
						})}
						onClick={onDeclineTerms}
					/>
					<Button
						kind="chromeless"
						label={formatMessage({
							id: 'terms-and-conditions.footer.button.cancel.label',
						})}
						onClick={togglePanelOpen}
					/>
				</div>
			}
		>
			<Feedback
				icon={
					<IconVerify
						size="large"
						className="terms-and-condition-verify-icon"
					/>
				}
				size="large"
			>
				<p>{declineContent()}</p>
			</Feedback>
		</Panel>
	)
}
export function TermsAndConditionsFooter({
	showTermsFooter,
	mode,
	onShowCreateUserId,
	onHideTerms,
	onDeclineTerms,
	formatMessage,
}) {
	if (showTermsFooter) {
		return (
			<div>
				<span className="TermsAndConditionsFooter_Text">
					<strong>
						<FormattedMessage id="terms-and-conditions.footer.instruction" />
					</strong>
				</span>
				<Button
					className="terms-accept-button"
					kind="primary"
					onClick={() => {
						onShowCreateUserId()
					}}
				>
					<FormattedMessage id="terms-and-conditions.footer.button.accept.label" />
				</Button>
				<TermsAndConditionsDeclineButton
					mode={mode}
					onDeclineTerms={onDeclineTerms}
					formatMessage={formatMessage}
				/>
			</div>
		)
	}
	if (
		mode === PLINFOLEASE ||
		mode === RICOH ||
		mode === WFINFOLEASE ||
		mode === FORDPRO
	) {
		return (
			<div>
				<Button
					className="terms-close-button"
					kind="primary"
					onClick={() => onHideTerms()}
				>
					<FormattedMessage id="terms-and-conditions.footer.button.close.label" />
				</Button>
			</div>
		)
	}
	return <Fragment />
}

export function TermsAndConditions({
	show,
	showTermsFooter,
	termsToDisplay,
	termType,
	mode,
	onHideTerms,
	onShowCreateUserId,
	onDeclineTerms,
	intl,
}) {
	window.scrollTo(0, 1)
	const { formatMessage } = intl
	const headerMessageId =
		termType && termType.toLowerCase().includes('privacy')
			? 'terms-and-conditions.header.modal-dialog.policies.title'
			: 'terms-and-conditions.header.modal-dialog.terms.title'
	if (!show) {
		return null
	}
	return (
		<div className="TermsAndConditions">
			<div data-wf-efmya-media="print" style={{ display: 'none' }} />
			<BasicPrintArea>
				<BasicPrintButton
					label={formatMessage({
						id: 'terms-and-conditions-print-button',
					})}
				/>
				<h1>{formatMessage({ id: headerMessageId })}</h1>
				<TermsAndConditionsContent
					termsToDisplay={termsToDisplay}
					onShowCreateUserId={onShowCreateUserId}
				/>
			</BasicPrintArea>
			<TermsAndConditionsFooter
				showTermsFooter={showTermsFooter}
				mode={mode}
				onHideTerms={onHideTerms}
				onShowCreateUserId={onShowCreateUserId}
				onDeclineTerms={onDeclineTerms}
				formatMessage={formatMessage}
			/>
		</div>
	)
}
